module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-EVA_2.5b70d127.jpg";